import { Button } from '@qualtrics/ui-react';
import React from 'react';
import styles from './initialRetakeScreen.module.css';

const InitialRetakeScreen = ({onClick, evaluationPage}) => {
    return (
        <div className={styles['initial-retake-screen']}>
            <div className={styles['screen-text']}>
                {evaluationPage.retakePageText || "This evaluation task has already been completed"}
            </div>
            <Button
                kind="primary"
                onClick={onClick}
                className={styles['retake-evaluation-button']}
            >
                {evaluationPage.retakeButtonText || "Retake evaluation"}
            </Button>
        </div>
    );
};

export default InitialRetakeScreen;
